import { Tooltip, withStyles } from "@material-ui/core";

export const CTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: 'rgba(60, 60, 60, 100)',
        color: 'rgba(255, 255, 255, 100)',
        boxShadow: theme.shadows[1],
        fontSize: 14,
    },
}))(Tooltip);